import { render, staticRenderFns } from "./CellRenderSelfies.vue?vue&type=template&id=0cb00d35"
import script from "./CellRenderSelfies.vue?vue&type=script&lang=js"
export * from "./CellRenderSelfies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports